<template>
    <v-container fluid>
        <div class="text-center" v-if="distributors && distributors.length == 0 ">
            <v-card class="mb-4">
                <v-card-text>
                    <div>Your cart is currently empty.</div>
                    <v-btn @click="$router.push('locations')" class="white--text" color="green">
                        <v-icon color="white" left>mdi-cart</v-icon>
                        Shop Now
                    </v-btn>
                </v-card-text>

            </v-card>
        </div>
        <div class="text-center" v-if="distributors && distributors.length >1 && !cart">
            <h3>You have more than 1 cart open. Please select which one you'd like to view.</h3>
            <v-card :key="dist.id" class="mb-4" v-for="dist in distributors">
                <v-card-text>
                    <div>
                        <a @click="loadCart(dist)" href="">
                            <img :src="dist.distributorLogo" class="dist-logo-list"/>
                        </a>
                    </div>
                </v-card-text>
                <v-btn @click="loadCart(dist)" class="ma-2" color="green">
                    <v-icon>mdi-cart</v-icon>
                </v-btn>
                <v-btn @click="deleteCart(dist)" class="ma-2" color="orange">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-card>
        </div>
        <div v-if="cart">
            <cart-header :cart="cart"></cart-header>

                <v-btn @click="$router.push('/shop/'+cart.distributorId)" class="ma-2 white--text" color="green">
                    <v-icon>mdi-cart</v-icon>
                    Continue Shopping
                </v-btn>
                <v-btn @click="deleteCart(cart)" class="ma-2 white--text" color="orange">
                    <v-icon>mdi-delete</v-icon>
                    Delete Cart
                </v-btn>

            <v-card elevation="10">
                <v-card-text class="text-left flex mt-4">
                    <v-textarea
                            outlined
                            name="orderNote"
                            label="Order Note"
                            rows="2"
                            hide-details="auto"
                            v-model="orderNote"
                    ></v-textarea>
                </v-card-text>

                <v-card-text class="text-left flex">
                    <div>
                        <v-simple-table
                        >
                            <template v-slot:default>
                                <thead class="secondary">
                                <tr>
                                    <th class="white--text">Item</th>
                                    <th class="white--text text-right">Quantity</th>
                                    <th class="white--text text-right">Price</th>
                                    <th class="white--text text-right">Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr :key="item.id" v-for="item in items">
                                    <td>{{item.productName}}</td>
                                    <td class="text-right">{{item.quantity}}
                                        <v-btn @click="adjustQuantity(item)" small text>
                                            <v-icon small>mdi-pencil</v-icon>
                                        </v-btn>
                                    </td>
                                    <td class="text-right">{{formatCurrency(item.sellPrice)}}</td>
                                    <td class="text-right">{{formatCurrency(item.subTotal)}}</td>
                                </tr>
                                <tr>
                                    <td><b>Subtotal</b></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">{{formatCurrency(totals.subTotal)}}</td>
                                </tr>
                                <tr>
                                    <td><b>Sales Tax</b></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">{{formatCurrency(totals.salesTax)}}</td>
                                </tr>
                                <tr>
                                    <td><b>Order Total</b></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><b>{{formatCurrency(totals.orderTotal)}}</b></td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                </v-card-text>
            </v-card>
            <v-card class="mt-4" elevation="10">
                <v-card-title class="secondary white--text">Next Step</v-card-title>
                <v-card-text class="text-left flex mt-4">
                    <v-btn @click="$router.push('/checkout/'+ cart.id)">
                        <v-icon>mdi-credit-card</v-icon>
                        Check Out
                    </v-btn>
                </v-card-text>
            </v-card>

        </div>

        <v-dialog max-width="290" persistent v-model="deleteCartDialog">
            <v-card v-if="deleteCandidate">
                <v-card-title class="red white--text" color="red">Delete Cart?</v-card-title>
                <v-card-text>Are you sure you wish to delete the cart for {{deleteCandidate.distributorName}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deleteCartDialog = false" class="white--text" color="green">Never Mind</v-btn>
                    <v-btn @click="doDeleteCart" class="white--text" color="orange">Yes, Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="290" persistent v-model="errorDialog">
            <v-card>
                <v-card-title class="red white--text" color="red">Error</v-card-title>
                <v-card-text>{{errorText}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="errorDialog = false" class="white--text" color="green" text>OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="quantityDialog">
            <v-card v-if="currentItem">
                <v-card-title class="secondary white--text">{{currentItem.productName}} Quantity</v-card-title>
                <v-card-text>
                    <v-text-field :rules="qtyRules" label="Quantity" type="number" v-model="newQuantity"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="submitQuantity" class="white--text" color="green">
                        <v-icon>mdi-check</v-icon>
                        Change
                    </v-btn>
                    <v-btn @click="quantityDialog = false" class="white--text" color="orange">
                        <v-icon>mdi-cancel</v-icon>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
                :timeout="snackbarTimeout"
                top
                v-model="snackbar"
        >
            {{ snackbarText }}
            <v-btn
                    @click="snackbar = false"
                    color="pink"
                    text
            >
                Close
            </v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api";
    import CartHeader from "./CartHeader";

    export default {
        name: 'Cart',
        components: {CartHeader},
        computed: {
            apiKey: function () {
                return this.$store.state.apiKey
            },
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            executing: function () {
                return this.$store.state.executing
            },
            totals: function () {
                let r = {subTotal: 0, salesTax: 0, orderTotal: 0}
                for (let i = 0; i < this.items.length; i++) {
                    let item = this.items[i]
                    r.subTotal += item.subTotal
                    r.salesTax += item.salesTax
                    r.orderTotal += item.itemTotal
                }
                return r
            },
            orderNote: {
                get() {
                    return this.$store.state.orderNote;
                },

                set(v) {
                    this.$store.commit('SET_ORDER_NOTE', v);
                }
            }
        },
        data: () => ({
            errorText: "",
            errorDialog: false,
            deleteCartDialog: false,
            deleteCandidate: null,
            pickupDate: null,
            pickupSlot: null,
            distributors: null,
            cart: null,
            items: [],
            currentItem: null,
            quantityDialog: false,
            snackbar: false,
            snackbarText: "",
            snackbarTimeout: 2500,
            newQuantity: null,
            qtyRules: [
                v => v >= 0 || "Quantity can't be less than 0"
            ]
        }),
        mounted() {
            window.scrollTo(0, 0)
            this.distList()
        },
        methods: {
            submitQuantity() {
                this.$store.dispatch("setExecuting", true)
                this.quantityDialog = false
                this.currentItem.quantity = parseInt(this.newQuantity)
                api.post("/consumer/cartItem", this.currentItem).then(
                (results) => {
                    this.$store.dispatch("setCartSize", results.data.cartSize)
                    if (results.data.item.quantity == 0) {
                        let loc = this.items.indexOf(this.currentItem)
                        this.items.splice(loc, 1)
                    } else {
                        this.currentItem.subTotal = results.data.item.subTotal
                        this.currentItem.sellPrice = results.data.item.sellPrice
                        this.currentItem.salesTax = results.data.item.salesTax
                        this.currentItem.itemTotal = results.data.item.itemTotal
                    }
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            adjustQuantity(item) {
                this.currentItem = item
                this.newQuantity = item.quantity
                this.quantityDialog = true
            },
            formatCurrency(n) {
                return "$" + n.toFixed(2)
            },
            deleteCart(dist) {
                this.deleteCandidate = dist
                this.deleteCartDialog = true
            },
            doDeleteCart() {
                this.deleteCartDialog = false
                this.$store.dispatch("setExecuting", true)
                api.delete("/consumer/cart/" + this.deleteCandidate.id).then(
                (results) => {
                    let loc = this.distributors.indexOf(this.deleteCandidate)
                    this.cart = null
                    this.items = []
                    this.distributors.splice(loc, 1)
                    this.deleteCandidate = null
                    this.$store.dispatch("setCartSize", results.data.cartSize)
                    this.$router.push("/")
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            distList() {
                this.$store.dispatch("setExecuting", true)
                api.get("/consumer/cartDistributors/").then(
                (results) => {
                    this.distributors = results.data
                    if (this.distributors.length == 1) {
                        this.loadCart(this.distributors[0])
                    }
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
            loadCart(distributor) {
                this.$store.dispatch("setExecuting", true)
                api.get("/consumer/cart/" + distributor.id).then(
                (results) => {
                    this.cart = results.data.cart
                    this.items = results.data.items
                },
                (error) => {
                    this.errorText = error.response.data
                    this.errorDialog = true
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            }

        }
    }
</script>
<style scoped>
    .dist-logo-list {
        max-height: 100px;
    }
</style>
